import FormComponent from "../FormComponent";
import TextComponentProps from "./types";

const TextComponent: React.FC<TextComponentProps> = ({
    name,
    label,
    required,
    formData,
    topTooltip,
    bottomTooltip,
    leftTooltip,
    rightTooltip,
    max,
    display
}) => {
    return (
        <FormComponent
            name={name}
            label={label}
            required={required}
            formData={formData}
            topTooltip={topTooltip}
            bottomTooltip={bottomTooltip}
            leftTooltip={leftTooltip}
            rightTooltip={rightTooltip}
            display={'-1'}
        >
            <input
                className="form-control"
                maxLength={max}
                width="100%"
                {...formData.getFieldProps(name)}
            />
        </FormComponent>
    );
};

export default TextComponent;